export default __webpack_public_path__ + "imgs/7bd89a28033623f4a3b3f3b0435c5d5a.png";